// Pinia Store
import { defineStore } from 'pinia'

import { format } from 'date-fns'

interface State {
  signedInDate: string

  toastMessage: Record<string, string>
}

export const useCommonStore = defineStore('common', {
  persist: {
    afterRestore: (context) => {
      context.store.bannerTitle = ''
      ;(context.store.modalPhotoStartIndex = -1),
        (context.store.modalPhotoCarouselIndexManual = -1),
        (context.store.toastMessage = {
          message: '',
          type: '',
        })
    },
  },
  // convert to a function
  state: (): State => ({
    signedInDate: '',

    toastMessage: {
      message: '',
      type: '',
    },
  }),

  getters: {
    getSignedInDate: (state) => {
      return state.signedInDate
    },

    getToastMessage: (state) => {
      console.log('getToastMessage')

      return state.toastMessage
    },
  },

  actions: {
    setSignedInDate() {
      this.signedInDate = format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSX")
    },

    resetSignedInDate() {
      this.signedInDate = ''
    },

    setToastSuccessMessage(message: string) {
      console.log('setToastSuccessMessage', message)

      this.toastMessage = {
        message: message,
        type: 'success',
      }
    },

    setToastDangerMessage(message: string) {
      console.log('setToastDangerMessage', message)

      this.toastMessage = {
        message: message,
        type: 'danger',
      }
    },

    setToastWarningMessage(message: string) {
      console.log('setToastWarningMessage', message)

      this.toastMessage = {
        message: message,
        type: 'warning',
      }
    },

    // easily reset state using `$reset`
    clearUser() {
      this.$reset()
    },
  },
})
